import { z } from 'zod'

import { EasyBuilderCampaignType } from '../../easyBuilder/types'

export enum RecommendationType {
  NO_TEMPLATE = 'no_template',
  UNDERPERFORMING_LINK = 'underperforming_link',
  LESS_COMMENTS = 'less_comments',
  INTEGRATION = 'integration',
}

const NoTemplateRecommendationSchema = z.object({
  type: z.literal(RecommendationType.NO_TEMPLATE),
  data: z.object({
    [EasyBuilderCampaignType.IG_CGT_NEXT_POST_MULTI_LINKS]: z.boolean(),
    [EasyBuilderCampaignType.IG_CGT_PRODUCT_GALLERY]: z.boolean(),
    [EasyBuilderCampaignType.IG_CGT_GROW_FOLLOWERS]: z.boolean(),
    setup_default_reply: z.boolean(),
  }),
})

const UnderperformingLinkRecommendationSchema = z.object({
  type: z.literal(RecommendationType.UNDERPERFORMING_LINK),
  data: z.object({
    percentage: z.number(),
    flow_ns: z.string(),
  }),
})

const LessCommentsRecommendationSchema = z.object({
  type: z.literal(RecommendationType.LESS_COMMENTS),
  data: z.object({
    change_percent: z.number(),
  }),
})

const IntegrationRecommendation = z.object({
  type: z.literal(RecommendationType.INTEGRATION),
  data: z.looseObject({}),
})

export const recommendationsSchema = z.object({
  data: z.array(
    z.union([
      NoTemplateRecommendationSchema,
      UnderperformingLinkRecommendationSchema,
      LessCommentsRecommendationSchema,
      IntegrationRecommendation,
    ]),
  ),
})

export type RecommendationsSchemaType = z.infer<typeof recommendationsSchema>

export type UnderperformingLinkRecommendationSchemaType = z.infer<
  typeof UnderperformingLinkRecommendationSchema
>

export type LessCommentsRecommendationSchemaType = z.infer<typeof LessCommentsRecommendationSchema>

export type NoTemplateRecommendationSchemaType = z.infer<typeof NoTemplateRecommendationSchema>
